import {
  createAuthAPI,
  createPublicAPI,
} from '../../utils/fetch/create-api-factory';
import {
  type AddressRequest,
  AddressResponseSchema,
  AddressSchema,
  AddressSearchResponseSchema,
  type PostcodeRequest,
  PostcodeResponseSchema,
} from './address.schema';

export const getAddress = (query: string, token: string) =>
  createAuthAPI<AddressRequest, typeof AddressSearchResponseSchema>({
    url: `${process.env.NEXT_PUBLIC_CONSUMER_SERVICE_URL}/address/search/address?q=${query}`,
    method: 'GET',
    schema: AddressSearchResponseSchema,
  })({ token });

export const getAddressPublic = (query: string) =>
  createPublicAPI<AddressRequest, typeof AddressSearchResponseSchema>({
    url: `${process.env.NEXT_PUBLIC_CONSUMER_PUBLIC_URL}/address/search/address?q=${query}`,
    method: 'GET',
    schema: AddressSearchResponseSchema,
  })({});

export const getPostcode = (query: string, token: string) =>
  createAuthAPI<PostcodeRequest, typeof PostcodeResponseSchema>({
    url: `${process.env.NEXT_PUBLIC_CONSUMER_SERVICE_URL}/address/search/postcode?q=${query}`,
    method: 'GET',
    schema: PostcodeResponseSchema,
  })({ token });

export const getPostcodePublic = (query: string) =>
  createPublicAPI<PostcodeRequest, typeof PostcodeResponseSchema>({
    url: `${process.env.NEXT_PUBLIC_CONSUMER_PUBLIC_URL}/address/search/postcode?q=${query}`,
    method: 'GET',
    schema: PostcodeResponseSchema,
  })({});

export const getAddressById = (id: string, token: string) =>
  createAuthAPI({
    url: `${process.env.NEXT_PUBLIC_CONSUMER_SERVICE_URL}/address/retrieve?id=${id}`,
    method: 'GET',
    schema: AddressSchema,
  })({ token });

export const getAddressByIdPublic = (id: string) =>
  createPublicAPI({
    url: `${process.env.NEXT_PUBLIC_CONSUMER_PUBLIC_URL}/address/retrieve?id=${id}`,
    method: 'GET',
    schema: AddressSchema,
  })({});

export const postAddress = createAuthAPI<
  AddressRequest,
  typeof AddressResponseSchema
>({
  url: `${process.env.NEXT_PUBLIC_CONSUMER_SERVICE_URL}/profile/addresses`,
  method: 'POST',
  schema: AddressResponseSchema,
});

export const putAddress = ({
  id,
  ...rest
}: {
  id: string;
  payload: AddressRequest;
  token: string;
}) =>
  createAuthAPI({
    url: `${process.env.NEXT_PUBLIC_CONSUMER_SERVICE_URL}/profile/addresses/${id}`,
    method: 'PUT',
    schema: AddressResponseSchema,
  })({ ...rest });
